<template>
  <f7-page name="profilePage">
    <div id="contact-page" class="profile-content users-full-table">
      <div class="sub-menu-wrapper">
        <SubMenu :items="MenuOptions.contexts.clientArea.items" />
      </div>
      <UsersDataTable :is-full-page="true" />
    </div>
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SubMenu from '@/components/SubMenu/index.vue';
import MenuOptions from '@/json/menuOptions.json';
import UsersDataTable from '@/components/UsersTable/index.vue';

export default {
  name: 'ClientAreaPage',
  components: {
    UsersDataTable,
    SubMenu,
  },
  data() {
    return {
      MenuOptions,
    };
  },
  computed: {
    ...mapState('contact', ['company']),
  },
  watch: {
    company() {
      this.clientAreaKey += 1;
    },
  },
  mounted() {
    this.setCurrentRoute([
      {
        name: this.$t('usersManagement'),
        disabled: false,
        page: 'UsersManagementFullPage',
        active: true,
      },
    ]);
  },
  methods: {
    ...mapActions('breadcrumb', ['setCurrentRoute']),
  },
};
</script>
<style lang="scss">
#contact-page {
  .sub-menu-wrapper {
    padding-bottom: 24px;
    border-bottom: 2px solid #c2d8f0;
    margin-bottom: 24px;
  }
}

.users-full-table
  .custom-grid-user-management
  .dx-gridbase-container
  > .dx-datagrid-rowsview {
  background: #fff;
}
.users-full-table
  .custom-grid-user-management
  .dx-datagrid-rowsview
  .dx-row,
.dx-datagrid .dx-row-lines > td {
  background: #f7f7f8;
  border: none !important;
}
.users-full-table .custom-grid-user-management .dx-datagrid-pager {
  border-top: none !important;
  background: #fff !important;
}
.users-full-table .custom-grid-user-management .dx-datagrid-headers {
  background: #fff !important;
}
</style>
